import { getTimelineGroupedSummary } from '@api';
import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const coreTimelineGroupedSummaryGetAsyncSlice = createGetAsyncSlice({
	name: 'CoreTimelineGroupedSummary',
	receive: true,
	request: true,
	requestHandler: getTimelineGroupedSummary,
	retainDataOnRequest: true,
	yieldType: SagaYieldType.Latest
});
